var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 33,
    viewBox: "0 0 162 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 41.9526,
    y: 4.32568,
    width: 23.9337,
    height: 23.9337,
    fill: "url(#pattern0)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 65.8865,
    y: 4.32568,
    width: 23.9337,
    height: 23.9337,
    fill: "url(#pattern1)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 89.8201,
    y: 4.32568,
    width: 23.9337,
    height: 23.9337,
    fill: "url(#pattern2)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 113.754,
    y: 4.32568,
    width: 23.9337,
    height: 23.9337,
    fill: "url(#pattern3)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 137.688,
    y: 4.32568,
    width: 23.9337,
    height: 23.9337,
    fill: "url(#pattern4)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0.523193,
    y: 0.55957,
    width: 31.5028,
    height: 31.5028,
    fill: "url(#pattern5)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_87_160",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_87_160",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_87_160",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern3",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_87_160",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern4",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_87_160",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern5",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_87_160",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_87_160",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFNklEQVR4nO2dWYgcVRSGf5e4EnHHuESN4oML4o4PgsYdQQiKIHkxuCJixojbkyO+5EU0+OSb5HFAJBoyU+fU2C5jYnQkroiKEoWoCYkrJqgTf7nV3do93Z2uqq7uc29ZH/yPQ53zz+3Tde899zZQUVFRUVFREQ6s4UDGuJaKaziBA6zjKSWcxQIK3qaCDb3ljLeOq3RQsbzF5KaWW8dVOqhY32G04FXruEoFaziSij+6GP0np3C0dXylgYIVXcpGXRHusI6vNFAw2dNowQbr+EoB1+OormWjtXwojrGOM3gouLunyf+ZfZd1nMFDgaYwWqzjDBrWcCwFf/U1WjHHCMdbxxssFNyXwuS6YtxrHW+wUPBaaqMV09bxBglrOCEpCemN3stJLLKOOzgoeCCDyU3dbx13cFDwZg6jX7eOOyg4iUVJKchu9F7GOMk6/mCgYGUOk5t60Dr+YGD7An9WzVjHHwSs4WQK/s5tdP1vF1vn4T1UrBpgNDf1kHUe3kPFOwUYvck6D6+hYvFAZaO1fEziNOt8vIUxHi1gNDf1iHU+3kLFbGFGC961zsdLqFhSSNlo1RTOtM7LO6h4olCT63ocZce1bCX7ffM1mUyvl3TRB0MwekvXZ7kNhS6xjd6kGJdSEVHwVZsU26n4sUNFf+TVK831yPmHLv5MUXFJOpM34AgqdnmQIIOUYCdnsDDNaL7CPFgNXpenGdHHUbDHg2AZpAS73XdAuvIhuJmCX82D1sAk+M15l8rkf81WnNX41rZPQAOQ4FNO45xMJreUkYMpWGOehHqvtXwFh+Uyuc3wCMsarzXWCdErufIquH1gg9vMnsapbvnRPDn1RIL3hzbFTw7rKFaXfILCFCa/4MrqUEzueCv5f05qfqHgtqEb3Gb2FE5xG6EeJM8R6T23TjJSk+eVkvGcPRgMQq5MujevCRxkYnKb4e6ApVtkKZ/JO6m4CR62CeRp46KXEmz2dt8xWYMOvZRIo1TMYgF8hxGWUvGduWmaWTsY40aEhDvqkGwehDOSaxSciBAhsR8Fj2VsKB99qXCTsDLclkDFlVRsMze1U9sZ4TqUCdZLyRcejeTPS3mSi+6+DZ9WAAU/BfFmkWtSox4Y3KoIS1E2qHje3NjOUb0GZYLu7UPxrbmxnfrGxYayQMHFHpjaXTEuRFmg4GlzQ3vrKZQFKj72wNDuEnyIMsBpnGFuZn/ZLOgXCQUPe2BkP61C6ASyRv0GSjDtnvPAyH6acz2HCBXGuNMDE5lKghUIFSrWDcGUTUNq5FmHEHG9aFT8XujHW7E6WZxyu+9unbt+FVtRI3o3IxyO0KDilgJN2Ooa5DueEeEyKr4s7DkRliE0kg7LYgyYcHeT9nzODBYmLVrF/ENfREgku+H1nohBEv85y7XFjHFrAW1qu4K6k7qxCz7IyNqYZ7aWtKm5TdZBnh3jKoRC7uZ1SS4THB9ko7SxIbxyn/eZ7lvPIRSo+DpHgp8xwkUFxnAeFR/l+GdvDWKN2q3v5jB57TBerbgRhyafruz93BfAd9z6boaEdmQ+xZQnJsH1FHyfIa5x+I5b3035EZVRdgY11l06fyegu7bAZ1z3ZQqD9ySzuiexv9He5T2pZqwRToevuEuj+pj8CadwvnmcMc7ue4ZSMIbg7uKXpBX2mZEcsEkJaziEimd7flH6/NsBPSYL29zPLsFTXO9djxbjGL7ijiHMu8H8pRB+6ID1m9dfbhnNLocb4DPJREEwRsHVCAzWz+KMMcK51rFUVFRUVFRUVFTAZ/4Bm54pyiuE8+oAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_87_160",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleReview);
export default __webpack_public_path__ + "static/media/google_review.2b1ecb93f7ac4cbc0aef65a64de3dc22.svg";
export { ForwardRef as ReactComponent };